<seds-form-field-core [iconPosition]="'left'" [iconName]="iconName" [color]="color" [type]="type" [label]="label">
  <input matInput #inputValue type="text" [placeholder]="placeholder" (keyup.enter)="send(inputValue.value)" />
  <button matSuffix class="button" (click)="send(inputValue.value)">Pesquisar</button>
</seds-form-field-core>
